import type { ReactNode } from "react";
import { observer } from "mobx-react-lite";
import type { AccountDataScope } from "./AccountDataScope";
import { MyOrdersPanel } from "./MyOrdersPanel";
import "./AccountPage.css";

type Props = {
  scope: AccountDataScope;
  topBar: ReactNode;
  /** 顶栏 position:fixed 时为 true */
  fixedTopBar?: boolean;
};

function CustomerOrdersPage(props: Props): JSX.Element {
  const { scope, topBar, fixedTopBar = false } = props;
  const mainClass = fixedTopBar
    ? "customer-account-page__main customer-account-page__main--below-fixed-top"
    : "customer-account-page__main";
  return (
    <div className="customer-account-page">
      {topBar}
      <main className={mainClass}>
        <div className="customer-account-page__inner">
          <div className="customer-account-page__card">
            <h1 className="customer-account-page__title">我的订单</h1>
            <MyOrdersPanel scope={scope} />
          </div>
        </div>
      </main>
    </div>
  );
}

export default observer(CustomerOrdersPage);
